module.exports = __webpack_public_path__ + "static/media/DownArrow.98ce5c44.svg";